module.exports = __webpack_public_path__ + "img/MOBILE_Slide2.efcb2e8f.png";